import React, { useState } from 'react';
import '../styles/Gallery.css';
import Modal from '../components/Modal';

const Uneheure = () => {
  const allMedia = [
    { name: 'Affiche une heure.jpg', protected: false, type: 'image' },
    { name: '1havance1.jpeg', protected: true, type: 'image' },
    { name: '1havance2.jpeg', protected: false, type: 'image' },
    { name: '1havance3.jpeg', protected: true, type: 'image' },
    { name: '1havance4.jpeg', protected: true, type: 'image' },
    { name: '1havance5.jpeg', protected: false, type: 'image' },
    { name: '1havance6.jpeg', protected: false, type: 'image' },
    { name: '1havance7.jpeg', protected: false, type: 'image' },
    { name: '1havance8.jpeg', protected: true, type: 'image' },
    { name: '1havance9.jpeg', protected: true, type: 'image' },
    { name: '1havance10.jpeg', protected: true, type: 'image' },
    { name: '1havance11.mp4', protected: false, type: 'video', preview: 'vignette_video.jpeg' },
    { name: '1havance12.jpeg', protected: true, type: 'image' },
    { name: '1havance13.jpeg', protected: true, type: 'image' },
    { name: '1havance14.jpeg', protected: false, type: 'image' },
    { name: '1havance15.jpeg', protected: false, type: 'image' },
    { name: '1havance16.jpeg', protected: false, type: 'image' },
    { name: '1havance17.jpeg', protected: false, type: 'image' },
    { name: '1havance18.jpeg', protected: false, type: 'image' },
    { name: '1havance19.jpeg', protected: false, type: 'image' },
    { name: '1havance20.jpeg', protected: false, type: 'image' },
    { name: '1havance21.jpeg', protected: false, type: 'image' },
    { name: '1havance22.jpeg', protected: true, type: 'image' },
    { name: '1havance23.jpeg', protected: true, type: 'image' },
    { name: '1havance24.jpeg', protected: false, type: 'image' },
    { name: '1havance25.jpeg', protected: false, type: 'image' },
    { name: '1havance26.jpeg', protected: true, type: 'image' },
    { name: '1havance27.jpeg', protected: false, type: 'image' },
    { name: '1havance28.jpeg', protected: false, type: 'image' },
    { name: '1havance29.jpeg', protected: true, type: 'image' },
    { name: '1havance30.jpeg', protected: false, type: 'image' },
    { name: '1havance31.jpeg', protected: false, type: 'image' },
    { name: '1havance32.png', protected: false, type: 'image' },
    { name: '1havance33.png', protected: true, type: 'image' },
    { name: '1havance34.png', protected: false, type: 'image' },
    { name: '1havance35.png', protected: false, type: 'image' },
    { name: '1havance36.png', protected: false, type: 'image' },
    { name: '1havance37.png', protected: false, type: 'image' },
    { name: '1havance38.png', protected: false, type: 'image' },
    { name: '1havance39.png', protected: true, type: 'image' },
    { name: '1havance40.png', protected: true, type: 'image' },
    { name: '1havance41.png', protected: false, type: 'image' },
    { name: '1havance42.png', protected: false, type: 'image' },
    { name: '1havance43.png', protected: false, type: 'image' },
    { name: '1havance44.png', protected: true, type: 'image' },
    { name: '1havance45.png', protected: true, type: 'image' },
    { name: 'youtube-video', protected: true, type: 'youtube', preview: 'vignette_youtube.jpeg', youtubeId: 'Em-Fartk5O8' },
  ];

  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [modalImage, setModalImage] = useState(null);
  const [modalAltText, setModalAltText] = useState("");
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [currentVideo, setCurrentVideo] = useState(null);
  const [showYouTubeModal, setShowYouTubeModal] = useState(false);
  const correctPassword = "Lzsvc123@";

  const openMedia = (mediaName, altText) => {
    const media = allMedia.find((m) => m.name === mediaName);

    if (!media) {
      console.error("Média non trouvé :", mediaName);
      return;
    }

    if (media.protected && !isPasswordValid) {
      const userPassword = prompt("Ce média est protégé. Veuillez entrer le mot de passe :");
      if (userPassword !== correctPassword) {
        alert("Mot de passe incorrect !");
        return;
      }
      setIsPasswordValid(true);
    }

    const mediaPath = `/album/uneheure/${mediaName}`;

    if (media.type === 'video') {
      setCurrentVideo(mediaPath);
      setShowVideoModal(true);
    } else if (media.type === 'youtube') {
      setShowYouTubeModal(true);
    } else {
      setModalImage(mediaPath);
      setModalAltText(altText);
    }
  };

  const closeModal = () => {
    setModalImage(null);
    setModalAltText("");
  };

  const closeVideoModal = () => {
    setShowVideoModal(false);
    setCurrentVideo(null);
  };

  const closeYouTubeModal = () => {
    setShowYouTubeModal(false);
  };

  return (
    <div className="album-detail">
      <h1>Album une heure d'avance</h1>

      {!isPasswordValid && (
        <div className="password-prompt">
          <button
            onClick={() => {
              const userPassword = prompt("Entrez le mot de passe pour déverrouiller les médias protégés :");
              if (userPassword === correctPassword) {
                setIsPasswordValid(true);
              } else {
                alert("Mot de passe incorrect !");
              }
            }}
          >
            Déverrouiller les médias protégés
          </button>
        </div>
      )}

      <div className="image-gallery">
        {allMedia.map((media, index) => {
          if (media.protected && !isPasswordValid) {
            return null;
          }

          const isVideo = media.type === 'video';
          const isYouTube = media.type === 'youtube';

          return (
            <div
              key={index}
              className="media-thumbnail"
              onClick={() => openMedia(media.name, `Détail du média ${index + 1}`)}
            >
              {isVideo ? (
                <img
                  src={`/album/uneheure/${media.preview}`}
                  alt={`Vignette ${index + 1}`}
                  className="album-image"
                />
              ) : isYouTube ? (
                <img
                  src={`/album/uneheure/${media.preview}`}
                  alt={`Vignette YouTube ${index + 1}`}
                  className="album-image youtube-thumbnail"
                />
              ) : (
                <img
                  src={`/album/uneheure/${media.name}`}
                  alt={`Média ${index + 1}`}
                  className="album-image"
                />
              )}
            </div>
          );
        })}
      </div>

      {/* Modal pour les images */}
      {modalImage && (
        <Modal image={modalImage} altText={modalAltText} onClose={closeModal} />
      )}

      {/* Modal pour les vidéos locales */}
      {showVideoModal && (
        <div className="video-modal-overlay" onClick={closeVideoModal}>
          <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
            <video className="video-modal-video" controls autoPlay>
              <source src={currentVideo} type="video/mp4" />
              Votre navigateur ne supporte pas la balise vidéo.
            </video>
            <button className="video-modal-close" onClick={closeVideoModal}>
              Fermer
            </button>
          </div>
        </div>
      )}

      {/* Modal pour YouTube */}
      {showYouTubeModal && (
        <div className="youtube-modal-overlay" onClick={closeYouTubeModal}>
          <div className="youtube-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="youtube-frame">
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/Em-Fartk5O8?autoplay=1&mute=1"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
            <button className="youtube-modal-close" onClick={closeYouTubeModal}>
              Fermer
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Uneheure;
